(function () {
  const GROUPS = [
    { from: 0, to: 0, className: "menu-group--top" },
    { from: 1, to: 7, className: "menu-group--led-indoor" },
    { from: 8, to: 12, className: "menu-group--unique" },
    { from: 13, to: 18, className: "menu-group--outdoor" },
    { from: 19, to: 22, className: "menu-group--tilbehor" },
    { from: 23, to: 29, className: "menu-group--seasons" },
  ];

  const HIDE_BY_MARKET = {
    DE: [13],
    SE: [13],
    NL: [13],
    FR: [13],
    BE: [13],
    AT: [13],
  };

  function getMarketKey() {
    const shopifyCountry =
      (window.Shopify && (Shopify.country || Shopify.locale)) || null;

    if (typeof shopifyCountry === "string" && shopifyCountry.length) {
      if (shopifyCountry.includes("-")) {
        const maybeCountry = shopifyCountry.split("-")[1];
        if (maybeCountry) return maybeCountry.toUpperCase();
      }
      if (shopifyCountry.length === 2) return shopifyCountry.toUpperCase();
    }

    const pathFirst = (location.pathname.split("/")[1] || "").toLowerCase();
    if (pathFirst && pathFirst.includes("-")) {
      const maybeCountry = pathFirst.split("-")[1];
      if (maybeCountry) return maybeCountry.toUpperCase();
    }

    return null;
  }

  function applyVisibility(root = document) {
    const nav = root.querySelector(".m-menu-drawer__navigation.m-menu-mobile");
    if (!nav) return;

    const items = Array.from(nav.querySelectorAll(":scope > .m-menu-mobile__item"));
    const market = getMarketKey();
    const hideIndexes = (market && HIDE_BY_MARKET[market]) || [];

    items.forEach((li) => {
      li.style.display = "";
      li.removeAttribute("data-hidden");
    });

    hideIndexes.forEach((idx) => {
      const li = items[idx];
      if (!li) return;
      li.style.display = "none";
      li.setAttribute("data-hidden", "true");
    });
  }

  function applyGroups(root = document) {
    const nav = root.querySelector(".m-menu-drawer__navigation.m-menu-mobile");
    if (!nav) return;

    const items = Array.from(nav.querySelectorAll(":scope > .m-menu-mobile__item"));

    items.forEach((li) => {
      Array.from(li.classList).forEach((c) => {
        if (c.startsWith("menu-group--")) li.classList.remove(c);
      });
      li.classList.remove("menu-group__item", "menu-group__first", "menu-group__last");
    });

    GROUPS.forEach((g) => {
      const from = Math.max(0, g.from);
      const to = Math.min(items.length - 1, g.to);
      if (to < from) return;

      const rangeItems = [];
      for (let i = from; i <= to; i++) {
        const li = items[i];
        if (!li) continue;
        if (li.style.display === "none" || li.getAttribute("data-hidden") === "true")
          continue;
        rangeItems.push(li);
      }

      if (!rangeItems.length) return;

      rangeItems.forEach((li) => li.classList.add("menu-group__item", g.className));

      rangeItems[0].classList.add("menu-group__first");
      rangeItems[rangeItems.length - 1].classList.add("menu-group__last");
    });
  }

  function run(root = document) {
    applyVisibility(root);
    applyGroups(root);
  }

  document.addEventListener("DOMContentLoaded", () => {
    run();

    const obs = new MutationObserver(() => run());
    obs.observe(document.documentElement, { childList: true, subtree: true });
  });
})();
